const SubscriptionPlan = () => import("../views/SubscriptionPlan");
const SubscriptionPlanForm = () => import("../views/SubscriptionPlanForm");

export default {
	children: [
		{
			path: "subscription_plan",
			name: "subscription_plan",
			component: SubscriptionPlan,
			meta: {
				requiresAuth: true,
				title: "lang.subscription_plan",
				restrict_by_permission: ["subscriptions.read"],
			},
		},
		{
			path: "subscription_plan/:id?",
			name: "subscription_plan",
			component: SubscriptionPlanForm,
			meta: {
				requiresAuth: true,
				title: "lang.subscription_plan",
				restrict_by_permission: ["subscriptions.read"],
			},
		},
	],
};
